<template>
  <div class="container page service-online-page">
    <van-nav-bar :title="$t('my.online_service') || 'Customer Service'" class="custom-nav" :border="false">
      <template #left>
        <van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <div class="service-card">
        <div class="card-header">
          <div class="avatar-wrap">
            <img class="avatar" src="/img/mine/kefu.png" alt="kefu">
          </div>
          <div class="service-info">
            <div class="name">{{this.$store.getters.getBaseInfo.name !==undefined ?this.$store.getters.getBaseInfo.name:this.$t("my.title")}}</div>
            <div class="status-dot">
              <span class="dot"></span> Online
            </div>
          </div>
          <button class="contact-btn" @click="toServicePage()">
            <van-icon name="chat-o" class="btn-icon" />
            {{$t("my.contact") || 'Contact'}}
          </button>
        </div>
        
        <div class="card-footer">
          <van-icon name="clock-o" class="time-icon" />
          <span class="time-text">{{ serviceTimeText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serviceTextConfig: {}
    };
  },
  computed: {
    // 客服工作时间文案：优先后台配置（按当前语言），否则语言包默认文案
    serviceTimeText() {
      const lang = this.$i18n ? this.$i18n.locale : 'en';
      const text = this.serviceTextConfig[lang] || this.serviceTextConfig['en'] || '';
      return text || this.$t("my.service_time") || 'Online working hours: 10:00 - 21:00';
    }
  },
  created() {
    this.getServiceText();
  },
  methods: {
    // 获取后台配置的在线客服文案（四种语言）
    getServiceText(){
      this.$http({
        method: 'get',
        url: 'service_text'
      }).then(res=>{
        if(res.code === 200 && res.data){
          this.serviceTextConfig = res.data;
        }
      })
    },
    back(){
      return window.history.back();
    },
    toServicePage(){
      const service = this.$store.getters.getBaseInfo;
      console.log(service)
      if (service.iskefu == 1){
        console.log('ssss')
        window.location.href = service.kefu
      }
      // this.$router.push("ServicePage");
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.service-online-page {
  background-color: #1f1c1f;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 导航栏暗金风格 */
.custom-nav {
  background-color: #2b2b2b !important;
  border-bottom: 2px solid #766350;
}
::v-deep .custom-nav .van-nav-bar__title {
  color: #e6b98a !important;
  font-size: 36px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

.main-content {
  flex: 1;
  padding: 30px 20px;
}

.service-card {
  background: #2b2b2b;
  border: 1px solid #3a3a3a;
  border-radius: 24px;
  padding: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #444;
  padding-bottom: 30px;
  margin-bottom: 30px;
  
  .avatar-wrap {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 2px solid #e6b98a;
    padding: 4px;
    margin-right: 24px;
    
    .avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  
  .service-info {
    flex: 1;
    
    .name {
      font-size: 36px;
      font-weight: bold;
      color: #e6b98a;
      margin-bottom: 12px;
    }
    
    .status-dot {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #999;
      
      .dot {
        width: 12px;
        height: 12px;
        background-color: #07c160;
        border-radius: 50%;
        margin-right: 8px;
        box-shadow: 0 0 8px #07c160;
      }
    }
  }
  
  .contact-btn {
    background: linear-gradient(90deg, #efcba7, #dcab76);
    border: none;
    border-radius: 40px;
    padding: 12px 30px;
    color: #4a2c1d;
    font-size: 28px;
    font-weight: bold;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 10px rgba(220, 171, 118, 0.3);
    
    .btn-icon {
      font-size: 32px;
      margin-right: 8px;
    }
    
    &:active {
      transform: scale(0.95);
    }
  }
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #766350;
  font-size: 26px;
  
  .time-icon {
    font-size: 32px;
    margin-right: 12px;
  }
}
</style>
